export const customerRoutes = {
  path: "/customer",
  component: () => import("@/layouts/Customer/CustomerLayout.vue"),
  children: [
    {
      path: "license_usage",
      name: "customerUsageRoute",
      component: () => import("@/modules/Usage/views/Customer"),
      redirect: {
        name: "customerUsageOverview",
      },
      children: [
        {
          path: "",
          name: "customerUsageOverview",
          component: () => import("@/modules/Usage/views/Customer/Overview"),
        },
      ],
    },
  ],
};

export default {};
